import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { useLang } from "@/i18n";
import { useAuth, homeFor } from "@/auth";
import { api } from "@/api";

export const LangToggle = () => {
  const { lang, setLang } = useLang();
  const pick = (l) => {
    setLang(l);
    api.post("/auth/lang", { lang: l }).catch(() => {});
  };
  return (
    <div className="flex border border-[#1A1A1A]" data-testid="language-toggle">
      {["en", "gu"].map((l) => (
        <button
          key={l}
          data-testid={`lang-${l}-button`}
          onClick={() => pick(l)}
          className={`px-3 py-1.5 text-xs font-bold uppercase tracking-wider transition-colors duration-200 ${
            lang === l ? "bg-[#1A1A1A] text-[#D4AF37]" : "text-[#1A1A1A] hover:bg-[#F3F1EB]"
          }`}
        >
          {l === "en" ? "EN" : "ગુ"}
        </button>
      ))}
    </div>
  );
};

export const Navbar = () => {
  const { t } = useLang();
  const { user } = useAuth();
  const links = [
    { href: "#plans", label: t("nav_plans"), id: "plans" },
    { href: "#calculator", label: t("nav_calculator"), id: "calculator" },
    { href: "#dsa", label: t("nav_dsa"), id: "dsa" },
    { href: "#contact", label: t("nav_contact"), id: "contact" },
  ];
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/70 backdrop-blur-xl backdrop-saturate-150 border-b border-white/40 shadow-sm">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-home-link">
          <Logo size={38} />
        </Link>
        <nav className="hidden lg:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.id}
              href={l.href}
              data-testid={`nav-${l.id}-link`}
              className="text-sm font-semibold text-[#5C5C5C] hover:text-[#1A1A1A] transition-colors duration-200 tracking-wide"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <LangToggle />
          {user ? (
            <Link
              to={homeFor(user.role)}
              data-testid="nav-dashboard-button"
              className="hidden sm:inline-block bg-[#1A1A1A] text-[#D4AF37] px-5 py-2.5 text-sm font-bold tracking-wide hover:bg-[#B5952F] hover:text-[#1A1A1A] transition-colors duration-200"
            >
              {t("nav_dashboard")}
            </Link>
          ) : (
            <>
              <Link
                to="/login"
                data-testid="nav-login-button"
                className="hidden sm:inline-block text-sm font-bold text-[#1A1A1A] px-4 py-2.5 hover:text-[#B5952F] transition-colors duration-200"
              >
                {t("nav_investor_login")}
              </Link>
              <Link
                to="/dsa-login"
                data-testid="nav-dsa-login-button"
                className="hidden sm:inline-block border border-[#1A1A1A] text-sm font-bold text-[#1A1A1A] px-4 py-2 hover:bg-[#1A1A1A] hover:text-[#D4AF37] transition-colors duration-200"
              >
                {t("nav_dsa_login")}
              </Link>
              <Link
                to="/register"
                data-testid="nav-join-button"
                className="bg-[#D4AF37] text-[#1A1A1A] px-5 py-2.5 text-sm font-bold tracking-wide hover:bg-[#1A1A1A] hover:text-[#D4AF37] transition-colors duration-200"
              >
                {t("nav_join")}
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
};
